var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MasterdataTableContainer',{attrs:{"loading":_vm.$apollo.loading,"headers":_vm.headers,"table-data":_vm.tableData,"sort-by":_vm.sortBy,"actions":_vm.actions,"refetch":_vm.refetch,"components":_vm.components}})
}
var staticRenderFns = []

export { render, staticRenderFns }